export async function getRealDataFav(addressesFav: Array<any>, callbackData: Function, callbackError: Function) {
    await Promise.all(addressesFav.filter((item: any) => !item.extId).map((item: any) => (postLocationName(item.description)))) //CONCURRENTE
        .then((data: any) => {
            const arrayAddresses: Array<any> = [];
            data.forEach((result: any, i: number) => {
                const response = result.json();
                response
                    .then((results: any) => {
                        const arrayLocations = findLocationMatch(results?.data?.stopLocationOrCoordLocation, addressesFav[i]);
                        if (arrayLocations) {
                            arrayAddresses.push(arrayLocations);
                        }
                        callbackData(arrayAddresses);
                    })
                    .catch((error: any) => callbackError(error))
            });
        })
}

export function findLocationMatch(arrayResponse: Array<any>, addr: any): any {
    for (let i = 0; i < (arrayResponse || []).length; i++) {
        const loc = arrayResponse[i];
        const item = loc?.CoordLocation?.id == addr?.hafasId || loc?.StopLocation?.id == addr?.hafasId;
        if (item) {
            if (!!item) {
                return { ...addr, ...loc?.CoordLocation || loc?.StopLocation };
            };
        }
    }
}

export function needImperativeData(addresses: Array<any> = []) {
    const arrayhasImperativeData: Array<boolean> = [];
    addresses.forEach((addr: any) => {
        arrayhasImperativeData.push(checkImperativeData(addr));
    });
    const mustHaveImperativeData = arrayhasImperativeData.filter((item: boolean) => item === false).length > 0;
    return mustHaveImperativeData;
}

export function checkImperativeData(addreses: any): boolean {
    const haveLat = addreses?.lat
    const haveLon = addreses?.lon
    const haveName = addreses?.name
    return !!haveLat && !!haveLon && !!haveName;
}

export function haveSameData(data1: Array<any>, data2: Array<any>) {
    return JSON.stringify(data1) === JSON.stringify(data2);
}

export async function postLocationName(locationName: string) {
    let BASIC_AUTH = window.location.host.includes("pre") ? "cmFhcy1hcGktY2xpZW50LXdlYjpBKFpkOEU2ZztEXSV9KUcjbSZSIUYkSmU" : (window.location.host.includes("int") || window.location.host.includes("local")) ? "cmFhcy1hcGktY2xpZW50LXdlYjpxP0AmNzxFNSFiOzhzUkQicFBHaFVjd0o" : "cmFhcy1hcGktY2xpZW50LXdlYjpFLk5VIkwrZFk7UHI1eDdbcGFUJ15zYmo";
    // const apiBasicAuth = "cmFhcy1hcGktY2xpZW50LXdlYjpBKFpkOEU2ZztEXSV9KUcjbSZSIUYkSmU"; //PRE

    // let API_ENV = window.location.host.includes("pre") ? "t" : "i";
    let API_ENV = window.location.host.includes("pre") ? "t" : (window.location.host.includes("int") || window.location.host.includes("local")) ? "i" : "p";
    let fetchURL = "https://eapi-raas-plan-v1-" + API_ENV + ".de-c1.cloudhub.io/api/v1/location-name?location=" + locationName;
    if (window.location.host.includes("localhost")) fetchURL = "http://localhost:3003/location-name?location=" + locationName + "&api=plan";

    const response = await fetch(fetchURL, {
        method: 'GET',
        mode: 'cors',
        headers: {
            "Authorization": "Basic " + BASIC_AUTH,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
        }
    })
    return response;
}